import { render } from "./gsgsSb.vue?vue&type=template&id=cd826e9e"
import script from "./gsgsSb.vue?vue&type=script&lang=js"
export * from "./gsgsSb.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__